import React, { useEffect, useState } from "react";
import { Spin, Typography, message } from "antd";
import { useParams } from "react-router-dom";
import AppLayout from "../components/layout/AppLayout";
import CustomerRequestDetail from "../components/transactions/CustomerRequestDetail";
import { getCustomerTransactionScheduleDetail } from "../api/customerTransactionApi";

const { Title } = Typography;

export default function RequestDetailPage() {
    const { id } = useParams();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const load = async () => {
            try {
                setLoading(true);
                const res = await getCustomerTransactionScheduleDetail(id);
                setData(res);
            } catch (error) {
                message.error(error.message || "Failed to load request detail");
            } finally {
                setLoading(false);
            }
        };

        load();
    }, [id]);

    return (
        <AppLayout>
            <Title level={2}>Request Detail</Title>
            {loading ? <Spin /> : <CustomerRequestDetail data={data} />}
        </AppLayout>
    );
}